import * as React from 'react';
import intl from 'react-intl-universal';

import { ReactComponent as ExpiredBg } from '@svg/mobile_questionnaire_expired.svg';

import './index.less';

const Expired: React.FC = () => {
    return (
        <div className="mobile-expired-wrapper">
            <ExpiredBg />
            <p className="expired-title">{intl.get('expired')}</p>
        </div>
    );
};

export default Expired;
